<template>
    <div class="finish">
        <h1>Aanvraagformulier</h1>
        <template v-if="loaded">
            <template v-if="complete">
                <template v-if="submitted">
                    <h2>Dank u wel</h2>

                    <p>
                        Wij zullen uw aanvraag binnenkort beoordelen.
                    </p>
                </template>
                <template v-else>
                    <h2>Aanvraag wordt ingediend...</h2>

                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-progress-circular color="primary" indeterminate class="ml-auto"></v-progress-circular>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </template>
            </template>
            <template v-else>
                <h2>Aanvraag onvolledig</h2>

                <p>
                    De aanvraag is nog niet volledig en kan nog niet ingediend worden.
                </p>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="back">Vorige stap</v-btn>
                    </v-col>
                </v-row>
            </template>
        </template>
        <template v-else>
            <h2>Indienen...</h2>

            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-progress-circular color="primary" indeterminate class="ml-auto"></v-progress-circular>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'finish',
    components: {},
    data: () => ({
        loaded: false,
        complete: null,
        submitted: null,
    }),
    created() {
        const that = this;
        this.finishLoad().then(function() {
            that.complete = that.vuex.complete;
            that.submitted = that.vuex.submitted;
            that.loaded = true;

            if (that.complete && !that.submitted) {
                that.submitted = true;
                that.loaded = false;
                that.finishSubmit(that.$data).then(function() {
                    that.complete = that.vuex.complete;
                    that.submitted = that.vuex.submitted;
                    that.loaded = true;
                });
            }
        });
    },
    computed: {
        ...mapGetters({ vuex: 'finish' }),
    },
    methods: {
        ...mapActions(['finishLoad', 'finishSubmit']),
        back: function() {
            this.$router.push({ name: 'step9_signature' });
        },
    },
};
</script>
